import script from "./ProgressStatistic.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressStatistic.vue?vue&type=script&setup=true&lang=js"

import "./ProgressStatistic.vue?vue&type=style&index=0&id=348a56b4&lang=scss"

const __exports__ = script;

export default __exports__